import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RADIO_GROUP_COLORS_MAP } from '../../../../constants';
import { RadioGroupColorType } from '../../../../types';
import { getRandomId } from '../../../../utils/get-random-id';
import { RadioGroupFieldComponent } from '../radio-group-field.component';

@Component({
  selector: 'fr8bot-ui-radio-option',
  templateUrl: './radio-option.component.html',
  styleUrl: './radio-option.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.flex]': 'group.optionFlex()',
    // A column never squeezes its option: the options wrap instead.
    '[style.min-width]': "group.optionFlex() ? 'max-content' : null",
  },
})
export class RadioOptionComponent<ValueType> {
  protected readonly group = inject<RadioGroupFieldComponent<ValueType>>(RadioGroupFieldComponent);

  readonly value = input<ValueType | null>(null);
  readonly color = input<RadioGroupColorType>('primary');
  readonly label = input<string | null>(null);
  readonly description = input<string | null>(null);
  readonly disabled = input(false);

  protected readonly id = getRandomId('radio-option');
  protected readonly isChecked = computed(() => this.group.value() === this.value());
  protected readonly isDisabled = computed(() => this.disabled() || this.group.disabled());
  protected readonly colorClass = computed(() => RADIO_GROUP_COLORS_MAP[this.color()]);
}
